<template>
  <!-- Feedback popunder -->
  <div class="fp">
    <v-btn
      v-bind="size"
      @click="toggleSlide(1)"
      class="hidden-sm-and-down mt-2 mr-2 abutton"
    >
      Give us <br />
      Feedback
    </v-btn>
    <!-- <button @click="toggleSlide(2)" class="test-btn">toggle slide 2</button>
    <button @click="toggleSlide(3)" class="test-btn">toggle slide 3</button> -->
    <!---->
    <!-- takes up full page -->
    <!---->
    <!-- popunder -->

    <div class="fp__cont">
      <!-- transition wrapper for slide 1 -->
      <transition name="popunder">
        <!-- slide 1, rate -->
        <div v-if="slide1Out" key="1" class="fp__slide1 fp__slide">
          <!-- top, title and subtitle -->
          <div class="fp__slide1__top">
            <div class="fp__slide1__top__left">&nbsp;</div>
            <div class="fp__slide1__top__center">
              <span class="fp__slide1__top__center__title">{{ title }}</span>
              <span class="fp__slide1__top__center__subtitle">{{
                subtitle
              }}</span>
            </div>
            <div class="fp__slide1__top__right">
              <div @click="toggleSlide(1)" class="fp__slide1__top__right__img">
                <svg
                  aria-hidden="true"
                  class="fp__slide1__top__right__img__svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 352 512"
                >
                  <path
                    fill="currentColor"
                    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <!-- bottom, pick rating -->
          <div class="fp__slide1__bottom">
            <!-- mood, terrible -->
            <div
              @click="clickMood(1)"
              class="fp__slide1__bottom__mood terrible"
            >
              <!-- svg container -->
              <div id="terrible-cont" class="fp__slide1__bottom__mood__img">
                <!-- terrible svg -->
                <svg
                  id="terrible-face"
                  class="fp__slide1__bottom__mood__img__svg svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32.1 32"
                >
                  <g id="face" transform="translate(-443 -206)">
                    <circle
                      id="terrible-circle"
                      cx="459.1"
                      cy="222"
                      r="16"
                      fill="#cfcfce"
                    ></circle>
                    <g id="Group_36" transform="translate(348.359 217.111)">
                      <circle
                        id="Ellipse_5"
                        class="st1"
                        cx="114.8"
                        cy="1.4"
                        r="2"
                      ></circle>
                    </g>
                    <g id="Group_37" transform="translate(340.259 217.111)">
                      <circle
                        id="Ellipse_6"
                        class="st1"
                        cx="114.8"
                        cy="1.4"
                        r="2"
                      ></circle>
                    </g>
                    <g id="Group_38" transform="translate(339.833 222.68)">
                      <path
                        id="Path_3"
                        class="st1"
                        d="M119.3-.6c2.7 0 5.2 1.6 6.4 4.1.2.5 0 1.1-.5 1.3s-1.1 0-1.3-.5c-1.2-2.5-4.2-3.6-6.7-2.4-1.1.5-2 1.4-2.5 2.4-.2.5-.8.7-1.3.5-.5-.3-.7-.8-.5-1.3 1.2-2.5 3.7-4.1 6.4-4.1z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <!-- mood title -->
              <span>Terrible</span>
            </div>

            <!-- mood, bad -->
            <div @click="clickMood(2)" class="fp__slide1__bottom__mood bad">
              <!-- svg container -->
              <div id="bad-cont" class="fp__slide1__bottom__mood__img">
                <!-- bad svg -->
                <svg
                  id="bad-face"
                  class="fp__slide1__bottom__mood__img__svg svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32.1 32"
                >
                  <g id="face" transform="translate(-443 -206)">
                    <circle
                      id="bad-circle"
                      cx="459.1"
                      cy="222"
                      r="16"
                      fill="#cfcfce"
                    ></circle>
                    <g id="Group_20" transform="translate(397.399 217)">
                      <circle
                        id="Ellipse_1"
                        class="st1"
                        cx="65.6"
                        cy="1.3"
                        r="1.9"
                      ></circle>
                      <circle
                        id="Ellipse_2"
                        class="st1"
                        cx="58"
                        cy="1.3"
                        r="1.9"
                      ></circle>
                    </g>
                    <path
                      id="Path_21"
                      class="st1"
                      d="M465.2 223.4c0-.5-.4-.9-.9-.9H464l-10.1 3.3c-.4.1-.8.4-.8.9s.4.9.9.9h.2l10.3-3.4c.5 0 .7-.4.7-.8z"
                    ></path>
                  </g>
                </svg>
              </div>
              <!-- mood title -->
              <span>Bad</span>
            </div>
            <!-- mood, okay -->
            <div @click="clickMood(3)" class="fp__slide1__bottom__mood okay">
              <!-- svg container -->
              <div id="okay-cont" class="fp__slide1__bottom__mood__img">
                <svg
                  id="okay-face"
                  class="fp__slide1__bottom__mood__img__svg svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32.1 32"
                >
                  <g id="face" transform="translate(-443 -206)">
                    <circle
                      id="okay-circle"
                      cx="459.1"
                      cy="222"
                      r="16"
                      fill="#cfcfce"
                    ></circle>
                    <g id="Group_20" transform="translate(453.665 218)">
                      <circle
                        id="Ellipse_1"
                        class="st1"
                        cx="9.2"
                        cy="1.1"
                        r="1.9"
                      ></circle>
                      <circle
                        id="Ellipse_2"
                        class="st1"
                        cx="1.7"
                        cy="1.1"
                        r="1.9"
                      ></circle>
                    </g>
                    <path
                      id="Path_22"
                      class="st1"
                      d="M465.4 226.2c.2-.4 0-1-.5-1.1-.1 0-.2-.1-.3-.1h-10.7c-.4-.1-.9.2-1 .6-.2.5.1 1 .6 1.2h11.1c.3 0 .7-.2.8-.6z"
                    ></path>
                  </g>
                </svg>
              </div>
              <!-- mood title -->
              <span>Okay</span>
            </div>
            <!-- mood, good -->
            <div @click="clickMood(4)" class="fp__slide1__bottom__mood good">
              <!-- svg container -->
              <div id="good-cont" class="fp__slide1__bottom__mood__img">
                <svg
                  id="good-face"
                  class="fp__slide1__bottom__mood__img__svg svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32.1 32"
                >
                  <g id="face" transform="translate(-443 -206)">
                    <circle
                      id="good-circle"
                      cx="459.1"
                      cy="222"
                      r="16"
                      fill="#cfcfce"
                    ></circle>
                  </g>
                  <circle
                    id="Ellipse_26"
                    class="st1"
                    cx="19.9"
                    cy="12.2"
                    r="1.9"
                  ></circle>
                  <circle
                    id="Ellipse_27"
                    class="st1"
                    cx="12.3"
                    cy="12.2"
                    r="1.9"
                  ></circle>
                  <path
                    id="Path_19"
                    class="st1"
                    d="M16.1 21.6c-2.6 0-4.9-1.5-6-3.8-.2-.5 0-1 .5-1.3.5-.2 1 0 1.3.5 1.1 2.4 3.9 3.4 6.3 2.3 1-.5 1.8-1.3 2.3-2.3.2-.5.8-.7 1.3-.5.5.2.7.8.5 1.3-1.3 2.4-3.6 3.8-6.2 3.8z"
                  ></path>
                </svg>
              </div>
              <!-- mood title -->
              <span>Good</span>
            </div>
            <!-- mood, great -->
            <div @click="clickMood(5)" class="fp__slide1__bottom__mood great">
              <!-- svg container -->
              <div id="great-cont" class="fp__slide1__bottom__mood__img">
                <svg
                  id="great-face"
                  class="fp__slide1__bottom__mood__img__svg svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32.1 32"
                >
                  <g id="face" transform="translate(-443 -206)">
                    <circle
                      id="great-circle"
                      cx="459.1"
                      cy="222"
                      r="16"
                      fill="#cfcfce"
                    ></circle>
                  </g>
                  <path
                    id="Path_20"
                    class="st1"
                    d="M21.8 16.3c-.2-.2-.4-.3-.7-.3h-10c-.5 0-.8.4-.8.8v.2c.9 3.2 4.2 5.2 7.4 4.3 2.1-.6 3.7-2.2 4.3-4.3 0-.3-.1-.5-.2-.7z"
                  ></path>
                  <g id="Group_34" transform="translate(572.554 217.625)">
                    <circle
                      id="Ellipse_3"
                      class="st1"
                      cx="-553"
                      cy="-205.4"
                      r="1.7"
                    ></circle>
                  </g>
                  <g id="Group_35" transform="translate(565.764 217.625)">
                    <circle
                      id="Ellipse_4"
                      class="st1"
                      cx="-553"
                      cy="-205.4"
                      r="1.7"
                    ></circle>
                  </g>
                </svg>
              </div>
              <!-- mood title -->
              <span>Great</span>
            </div>
          </div>
        </div>
        <!-- slide 2, feedback -->
        <div v-if="slide2Out" key="2" class="fp__slide2 fp__slide">
          <!-- top, title and subtitle -->
          <div class="fp__slide2__top">
            <div class="fp__slide2__top__left">
              <div @click="toggleSlide(1)" class="fp__slide2__top__left__img">
                <svg
                  aria-hidden="true"
                  data-prefix="fas"
                  data-icon="chevron-left"
                  class="fp__slide2__top__right__img__svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill="currentColor"
                    d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="fp__slide2__top__center">
              <span class="fp__slide2__top__center__title">{{
                feedbackTitle
              }}</span>
              <span class="fp__slide2__top__center__subtitle">{{
                feedbackSubtitle
              }}</span>
            </div>
            <div class="fp__slide2__top__right">
              <div @click="toggleSlide(2)" class="fp__slide2__top__right__img">
                <svg
                  aria-hidden="true"
                  class="fp__slide2__top__right__img__svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 352 512"
                >
                  <path
                    fill="currentColor"
                    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <!-- middle, feedback input -->
          <div class="fp__slide2__middle">
            <textarea v-model="feedbackText"></textarea>
          </div>
          <!-- bottom, submit button -->
          <div class="fp__slide2__bottom">
            <button
              @click="clickSubmit()"
              v-bind:class="{ hasFeedback: feedbackPresent }"
              class="fp__slide2__bottom__btn"
            >
              <span v-bind:class="{ show: isNotSubmitting, hide: isSubmitting }"
                >Submit</span
              >
              <div
                v-bind:class="{ show: isSubmitting, hide: isNotSubmitting }"
                class="fp__slide2__bottom__loader show-loader"
              >
                <svg
                  aria-hidden="true"
                  data-prefix="fas"
                  data-icon="spinner"
                  class="fp__slide3__loader__svg rotating"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="#ffffff"
                    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                  ></path>
                </svg>
              </div>
            </button>
          </div>
        </div>
        <!-- slide 3, done -->
        <div v-if="slide3Out" key="3" class="fp__slide3 fp__slide">
          <!-- slide 3 body -->
          <div class="fp__slide3__top">
            <div class="fp__slide3__top__left">&nbsp;</div>
            <div class="fp__slide3__top__center">
              <span class="fp__slide3__top__center__subtitle"
                >Feedback submitted!</span
              >
            </div>
            <div class="fp__slide3__top__right">
              <div @click="toggleSlide(3)" class="fp__slide3__top__right__img">
                <svg
                  aria-hidden="true"
                  class="fp__slide3__top__right__img__svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 352 512"
                >
                  <path
                    fill="currentColor"
                    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedbackPopup",
  props: {
    title: String,
    subtitle: String
  },
  data() {
    return {
      slide1Out: false,
      fName: "",
      slide2Out: false,
      slide3Out: false,
      slide4Out: false,
      feedbackTitle: "no selection",
      feedbackSubtitle: "no selection",
      isTerrible: false,
      isBad: false,
      isOkay: false,
      isGood: false,
      isGreat: false,
      feedbackText: "",
      isSubmitting: false,
      isNotSubmitting: true,
      submissionClicked: false,
      size: ""
    };
  },
  computed: {
    size() {
      const size = { xs: "x-small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    }
  },
  methods: {
    toggleSlide(slide) {
      if (slide === 1) {
        if (this.slide2Out || this.slide3Out) {
          this.slide2Out = false;
          this.slide3Out = false;
          setTimeout(() => (this.slide1Out = true), 300);
        } else {
          this.slide1Out = !this.slide1Out;
        }
      }
      if (slide === 2) {
        if (this.slide1Out || this.slide3Out) {
          this.slide1Out = false;
          this.slide3Out = false;
          setTimeout(() => (this.slide2Out = true), 300);
        } else {
          this.slide2Out = !this.slide2Out;
        }
      }
      if (slide === 3) {
        if (this.slide1Out || this.slide2Out) {
          this.slide1Out = false;
          this.slide2Out = false;
          setTimeout(() => (this.slide3Out = true), 300);
        } else {
          this.slide3Out = !this.slide3Out;
        }
      }
    },
    setAllMoodsFalse() {
      this.isTerrible = false;
      this.isBad = false;
      this.isOkay = false;
      this.isGood = false;
      this.isGreat = false;
    },
    clickMood(mood) {
      switch (mood) {
        case 1:
          this.setAllMoodsFalse();
          this.isTerrible = true;
          this.feedbackTitle = "Oh no!";
          this.feedbackSubtitle =
            "Please tell us about your frustrations, and Customer Care will reach out soon to help resolve them.";
          this.toggleSlide(2);
          break;
        case 2:
          this.setAllMoodsFalse();
          this.isBad = true;
          this.feedbackTitle =
            "We’re always committed to making your experience a good one";
          this.feedbackSubtitle = "What should we improve?";
          this.toggleSlide(2);
          break;
        case 3:
          this.setAllMoodsFalse();
          this.isOkay = true;
          this.feedbackTitle = "Thank you for your input";
          this.feedbackSubtitle =
            "What should we do to improve our rating to Good or Great?";
          this.toggleSlide(2);
          break;
        case 4:
          this.setAllMoodsFalse();
          this.isGood = true;
          this.feedbackTitle = "Glad you’re having a good experience";
          this.feedbackSubtitle =
            "Is there anything we can do to make it even better?";
          this.toggleSlide(2);
          break;
        case 5:
          this.setAllMoodsFalse();
          this.isGreat = true;
          this.feedbackTitle = "That’s awesome!";
          this.feedbackSubtitle =
            "Which of our services or information do you find the most valuable?";
          this.toggleSlide(2);
          break;
        default:
          console.log("invalid mood selected");
      }
    },
    clickSubmit() {
      this.submissionClicked = !this.submissionClicked;
      if (this.feedbackPresent) {
        this.isSubmitting = !this.isSubmitting;
        this.isNotSubmitting = !this.isNotSubmitting;
        setTimeout(() => this.toggleSlide(3), 500);
      }
    }
  },
  computed: {
    feedbackPresent: function() {
      if (this.feedbackText != "") {
        return true;
      } else {
        return false;
      }
    },
    submissionStatus() {
      if (this.isSubmitting) {
        return true;
      }
      if (this.isNotSubmitting) {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* variables */
$slideOutline: #dee2e6;
$slideBackground: #f7f7f7;
$textSize: 16px;
$subTextSize: 14px;
$textColor: #212529;
$textColorGray: #939393;
$textAreaOutline: #ced4da;
$textAreaBackground: #ffffff;
$activeBtnBackground: #2872bc;
$activeBtnText: #ffffff;
$inactiveBtnText: #c3c3c3;
$inactiveBtnBackground: #e6e6e6;
$navColor: #b9b9b9;
$navColorHover: #939393;
$terribleColor: #ff909a;
$badColor: #ffbf48;
$okayColor: #edd400;
$goodColor: #31e026;
$greatColor: #46b5fd;

/* mixins */
@mixin dflex {
  display: flex;
  flex-wrap: nowrap;
}

/* style */
.abutton {
  border-radius: 100rem;
  // font-weight: 700;
  transition: 0.5s;
  width: 90px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.abutton:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

.fp {
  z-index: 3;
  color: $textColor;
  // width: 100%;
  // height: 100%;
  background: secondary;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  &__cont {
    /* background-color: rgba(0, 0, 0, 0.25); */
    @include dflex;
    flex-direction: row;
    justify-content: center;
    // position: absolute;
    bottom: 30vh;
    top: 50vh;
    width: 100%;
  }
  &__slide {
    @include dflex;
    flex-direction: column;
    font-size: $textSize;
    padding: 0 1rem 1rem;
    margin: 0 1rem;
    background-color: #f0f2f5;
    border: 1px solid $slideOutline;
    //border-bottom: none;
    border-radius: 2rem;
    // border-top-right-radius: 2rem;
    // border-top-left-radius: 2rem;
    // border-top-right-radius: 2rem;
    min-width: 0%;
    width: 100%;
    max-width: 400px;
    -webkit-box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.075);
    -moz-box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.075);
    box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.075);
    transition: box-shadow 0.05s ease-out;

    &:hover {
      -webkit-box-shadow: 0px 0px 25px 0px rgba(219, 219, 219, 1);
      -moz-box-shadow: 0px 0px 25px 0px rgba(219, 219, 219, 1);
      box-shadow: 0px 0px 25px 0px rgba(219, 219, 219, 1);
    }
  }
  &__slide1 {
    z-index: 4;
    margin-top: 400px;
    &__top {
      @include dflex;
      flex-direction: row;
      justify-content: space-between;
      padding: 1rem 0 1.1rem 0;
      &__left {
        @include dflex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        min-width: 32px;
        width: 100%;
        max-width: 32px;
      }
      &__center {
        @include dflex;
        flex-direction: column;

        &__title {
          font-weight: bold;
        }
        &__subtitle {
          color: $textColorGray;
          font-size: $subTextSize;
          padding-top: 0.2rem;
        }
      }
      &__right {
        @include dflex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-start;
        min-width: 32px;
        width: 100%;
        max-width: 32px;

        &__img {
          width: 18px;

          svg {
            width: 100%;
            color: $navColor;
            transition: color 0.1s ease-in-out;
            &:hover {
              color: $navColorHover;
            }
          }
          &__svg {
            width: 100%;
            color: $navColor;
            transition: color 0.1s ease-in-out;
            &:hover {
              color: $navColorHover;
            }
          }
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    &__bottom {
      @include dflex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      color: #f0f2f5;
      height: 50px;
      &__mood {
        @include dflex;
        flex-direction: column;
        align-items: center;
        -webkit-transition: 0.1s ease-out;
        -moz-transition: 0.1s ease-out;
        -o-transition: 0.1s ease-out;
        transition: 0.1s ease-out;
        &__img {
          width: 32px;
          margin: 0;
          padding: 0;
          svg {
            width: 100%;
            margin: 0;
            padding: 0;
          }
          &__svg {
            width: 100%;
            margin: 0;
            padding: 0;
          }
        }
        span {
          font-size: $subTextSize;
          color: $textColorGray;
        }
        &:first-child {
          padding: 0 1rem 0 0;
          @media (max-width: 419.98px) {
            padding: 0 0.25rem 0 0;
          }
        }
        &:not(:first-child):not(:last-child) {
          padding: 0 1rem;
          @media (max-width: 419.98px) {
            padding: 0 0.25rem;
          }
        }
        &:last-child {
          padding: 0 0 0 1rem;
          @media (max-width: 419.98px) {
            padding: 0 0 0 0.25rem;
          }
        }
        &:hover {
          cursor: pointer;
          -webkit-transform: scale(1.4);
          -moz-transform: scale(1.4);
          -o-transform: scale(1.4);
          -ms-transform: scale(1.4);
          transform: scale(1.4);
        }
      }

      .terrible {
        &:hover {
          #terrible-circle {
            fill: $terribleColor;
          }
          span {
            color: $terribleColor;
          }
        }
      }

      .bad {
        &:hover {
          #bad-circle {
            fill: $badColor;
          }
          span {
            color: $badColor;
          }
        }
      }
      .okay {
        &:hover {
          #okay-circle {
            fill: $okayColor;
          }
          span {
            color: $okayColor;
          }
        }
      }
      .good {
        &:hover {
          #good-circle {
            fill: $goodColor;
          }
          span {
            color: $goodColor;
          }
        }
      }
      .great {
        &:hover {
          #great-circle {
            fill: $greatColor;
          }
          span {
            color: $greatColor;
          }
        }
      }
    }
  }
  &__slide2 {
    z-index: 4;
    margin-top: 400px;
    &__top {
      // background-color: rgba(0, 0, 0, 0.5);
      z-index: 4;
      @include dflex;
      flex-direction: row;
      justify-content: space-between;
      padding: 1rem 0 0.75rem 0;
      &__left {
        /* background-color: rgba(0, 0, 0, 0.1); */
        @include dflex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        min-width: 32px;
        width: 100%;
        max-width: 32px;

        &__img {
          width: 17px;

          svg {
            width: 100%;
            color: $navColor;
            transition: color 0.1s ease-in-out;
            &:hover {
              color: $navColorHover;
            }
          }
          &__svg {
            width: 100%;
            color: $navColor;
            transition: color 0.1s ease-in-out;
            &:hover {
              color: $navColorHover;
            }
          }
        }
        &:hover {
          cursor: pointer;
        }
      }
      &__center {
        @include dflex;
        flex-direction: column;

        &__title {
          font-weight: bold;
        }
        &__subtitle {
          color: $textColorGray;
          font-size: $subTextSize;
          padding-top: 0.2rem;
        }
      }
      &__right {
        /* background-color: rgba(0, 0, 0, 0.1); */
        @include dflex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-start;
        min-width: 32px;
        width: 100%;
        max-width: 32px;

        &__img {
          width: 18px;

          svg {
            width: 100%;
            color: $navColor;
            transition: color 0.1s ease-in-out;
            &:hover {
              color: $navColorHover;
            }
          }
          &__svg {
            width: 100%;
            color: $navColor;
            transition: color 0.1s ease-in-out;
            &:hover {
              color: $navColorHover;
            }
          }
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    &__middle {
      padding-right: 1.1rem;

      textarea {
        width: 100%;
        border-radius: 4px;
        border: 1px solid $textAreaOutline;
        background-color: $textAreaBackground;
        resize: none;
        font-size: $textSize;
        padding: 0.5rem;
      }

      textarea:focus {
        outline: none;
      }
    }
    &__bottom {
      margin-top: 0.5rem;

      &__btn {
        width: 100%;
        background-color: $inactiveBtnBackground;
        color: $inactiveBtnText;
        font-size: $textSize;
        padding: 0.5rem 0;
        border: none;
        border-radius: 4px;
        cursor: not-allowed;
        outline: none;
      }

      &__loader {
        width: 15px;
        padding: 0;
        margin: 0;
      }

      .hasFeedback {
        background-color: $activeBtnBackground;
        color: $activeBtnText;
        cursor: pointer;
      }
    }
  }
  &__slide3 {
    z-index: 4;
    margin-top: 400px;
    @include dflex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-bottom: 0;
    z-index: 4;

    &__top {
      /* background-color: rgba(0, 0, 0, 0.1); */
      @include dflex;
      flex-direction: row;
      justify-content: space-between;
      padding: 1rem 0 0.75rem 0;
      width: 100%;
      &__left {
        /* background-color: rgba(0, 0, 0, 0.1); */
        @include dflex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        min-width: 32px;
        width: 100%;
        max-width: 32px;
      }
      &__center {
        @include dflex;
        flex-direction: column;

        &__subtitle {
          color: $textColorGray;
          font-size: $subTextSize;
          padding-top: 0.2rem;
        }
      }
      &__right {
        /* background-color: rgba(0, 0, 0, 0.1); */
        @include dflex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-start;
        min-width: 32px;
        width: 100%;
        max-width: 32px;

        &__img {
          width: 18px;

          svg {
            width: 100%;
            color: $navColor;
            transition: color 0.1s ease-in-out;
            &:hover {
              color: $navColorHover;
            }
          }
          &__svg {
            width: 100%;
            color: $navColor;
            transition: color 0.1s ease-in-out;
            &:hover {
              color: $navColorHover;
            }
          }
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}

.show {
  display: inherit;
}

.hide {
  display: none;
}

/* vue transitions */
.popunder-enter-active,
.popunder-leave-active {
  transition: all 0.3s ease;
}
.popunder-enter,
.popunder-leave-to {
  transform: translateY(250px);
}

/* css3 animation for rotating loader */
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}

/* test stuff, can be deleted */
.test-btn {
  border: 1px solid black;
  border-radius: 4px;
  padding: 0;
  width: 120px;
  height: 35px;
  margin: 1rem;
}
</style>
